(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  class EditorialHeader extends HTMLElement {
    connectedCallback() {
      const nav = $('.ed-nav', this);
      const shade = $('.ed-nav-shade');
      const open = () => {
        nav?.classList.add('is-open'); shade?.classList.add('is-open');
        $('[data-ed-menu]', this)?.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
      };
      const close = () => {
        nav?.classList.remove('is-open'); shade?.classList.remove('is-open');
        $('[data-ed-menu]', this)?.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
      };
      $('[data-ed-menu]', this)?.addEventListener('click', open);
      $$('[data-ed-menu-close]').forEach((el) => el.addEventListener('click', close));
      $$('.ed-nav-item', this).forEach((item) => item.addEventListener('toggle', () => {
        if (!item.open || matchMedia('(max-width: 749px)').matches) return;
        $$('.ed-nav-item[open]', this).forEach((other) => { if (other !== item) other.open = false; });
      }));
    }
  }

  class EditorialTabs extends HTMLElement {
    connectedCallback() {
      const tabs = $$('[role="tab"]', this);
      tabs.forEach((tab, index) => tab.addEventListener('click', () => {
        tabs.forEach((button, i) => {
          const active = i === index;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
          const panel = $(`#${CSS.escape(button.getAttribute('aria-controls'))}`, this);
          if (panel) panel.hidden = !active;
        });
      }));
      $$('[data-ed-scroll]', this).forEach((button) => button.addEventListener('click', () => {
        const track = $('[data-ed-track]', button.closest('[role="tabpanel"]'));
        track?.scrollBy({ left: Number(button.dataset.edScroll) * track.clientWidth * .8, behavior: 'smooth' });
      }));
    }
  }

  const wishlistKey = 'editorial-wishlist-v1';
  const readWishlist = () => { try { return JSON.parse(localStorage.getItem(wishlistKey)) || []; } catch { return []; } };
  const safe = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
  const renderWishlist = () => {
    const target = $('[data-ed-wishlist-items]');
    if (!target) return;
    const items = readWishlist();
    target.innerHTML = items.length ? items.map((item) => `<div class="ed-wishlist-item"><img src="${safe(item.image)}" alt=""><a href="${safe(item.url)}">${safe(item.title)}</a><button type="button" data-ed-remove="${safe(item.url)}" aria-label="Remove">×</button></div>`).join('') : '<p>Your wishlist is empty.</p>';
    $$('[data-ed-remove]', target).forEach((b) => b.addEventListener('click', () => {
      localStorage.setItem(wishlistKey, JSON.stringify(items.filter((x) => x.url !== b.dataset.edRemove)));
      renderWishlist();
    }));
  };

  if (!customElements.get('editorial-header')) customElements.define('editorial-header', EditorialHeader);
  if (!customElements.get('editorial-tabs')) customElements.define('editorial-tabs', EditorialTabs);

  const setupWishlists = (root = document) => {
    $$('.ed-products .product-card, .product-grid .product-card', root).forEach((card) => {
      if ($('.ed-card-wish', card)) return;
      const link = $('.product-card__link', card);
      if (!link) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ed-card-wish';
      button.setAttribute('aria-label', 'Save to wishlist');
      button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M12 21 3.2 12.5C-3 6 5.8-1 12 6c6.2-7 15 0 8.8 6.5Z"/></svg>';
      const item = { url: link.getAttribute('href'), title: link.textContent.trim(), image: $('img', card)?.currentSrc || $('img', card)?.src || '' };
      const refresh = () => button.setAttribute('aria-pressed', String(readWishlist().some((entry) => entry.url === item.url)));
      button.addEventListener('click', () => {
        let items = readWishlist();
        items = items.some((entry) => entry.url === item.url) ? items.filter((entry) => entry.url !== item.url) : [...items, item];
        localStorage.setItem(wishlistKey, JSON.stringify(items));
        refresh();
      });
      refresh();
      card.append(button);
    });
  };
  setupWishlists();
  new MutationObserver((records) => { if (records.some((record) => record.addedNodes.length)) setupWishlists(); }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ed-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.edOpen);
      if (dialog?.showModal) { if (dialog.id === 'EdWishlist') renderWishlist(); dialog.showModal(); }
    }
    const close = event.target.closest('[data-ed-close]');
    if (close) close.closest('dialog')?.close();
    const videoButton = event.target.closest('[data-ed-video]');
    if (videoButton) {
      const video = $('video', videoButton.closest('.ed-hero'));
      if (!video) return;
      video.paused ? video.play() : video.pause();
      videoButton.textContent = video.paused ? 'Play' : 'Pause';
      videoButton.setAttribute('aria-label', videoButton.textContent + ' video');
    }
  });
})();
